/* eslint-disable @typescript-eslint/no-explicit-any */
import {Text, View} from '@react-pdf/renderer';
import React from 'react';
import {DateToddmmyyyyFormatNoError} from '../../../../data/factory';
import {styles} from './styles';

export const AssurranceRetraite = (props: any) => {
  const getCurrentDate = () => DateToddmmyyyyFormatNoError(new Date());
  const {detailContrat} = props;
  return (
    <View>
      <View style={{margin: 10}} />
      <Text style={styles.title}>VOTRE ASSURANCE RETRAITE COMPLEMENTAIRE</Text>
      <Text style={styles.title}>CONDITIONS PARTICULIÈRES</Text>
      <View style={styles.sousSection}>
        <Text style={{margin: 5}}>
          Sur la base de la proposition n°___________{' '}
        </Text>
        <Text>
          <Text style={styles.subtitle1}>SOUSCRIPTEUR : </Text>{' '}
          {detailContrat.nomPrenomContractant}
        </Text>
        <Text>
          <Text style={styles.subtitle2}>Adresse: </Text>{' '}
          {detailContrat.adresse}
        </Text>
        <Text>
          <Text style={styles.subtitle2}>Téléphone n°: </Text>{' '}
          {detailContrat.telephoneContractant}
          <Text style={styles.subtitle2}>{'   '}E - mail: </Text>{' '}
          {detailContrat.emailContractant}
          <Text style={styles.subtitle2}>{'   '}CIN n°: </Text>
        </Text>
        <Text>
          Veuillez informer l’Assureur en cas de changement de coordonnée
        </Text>
        <View style={{margin: 5}} />
        <Text>
          <Text style={styles.subtitle1}>ASSURE : </Text>{' '}
          {detailContrat.nomPrenomAssure}
        </Text>
        <Text>
          <Text style={styles.subtitle2}>Date et lieu de naissance : </Text>{' '}
          {detailContrat.dateNaissanceAssure}{' '}
        </Text>
        <Text>
          <Text style={styles.subtitle2}>Adresse : </Text>{' '}
          {detailContrat.adresseAssure}{' '}
        </Text>
        <Text>
          <Text style={styles.subtitle2}>Téléphone n°: </Text>{' '}
          {detailContrat.telephoneAssure}
          <Text style={styles.subtitle2}>{'   '}E - mail: </Text>{' '}
          {detailContrat.emailAssure}
          <Text style={styles.subtitle2}>{'   '}CIN n°: </Text>
        </Text>
        <Text>
          Veuillez informer l’Assureur en cas de changement de coordonnée
        </Text>
        <View style={{margin: 3}} />
        <Text>
          <Text style={styles.subtitle1}>
            BENEFICIAIRE(S) EN CAS DE DECES :{' '}
          </Text>
        </Text>
        <Text>{detailContrat.beneficiaireCasDeces}</Text>
        <Text
          style={{...styles.textBolded, alignSelf: 'flex-end', marginTop: 20}}>
          Fait à Antananarivo, le {getCurrentDate()}
        </Text>
        <View style={{margin: 5}} />
        <Text style={{...styles.textBolded, alignSelf: 'flex-end'}}>
          L’ASSUREUR{' '}
        </Text>
        <View style={{margin: 30}} />
        <Text>
          Le Souscripteur a la faculté de renoncer au présent contrat dans un
          délai de 30 j (trente jours) à compter du premier versement
        </Text>
        <Text>
          (article 169 de la loi n°99- 13). La restitution de la prime nette de
          taxes entraîne la nullité du contrat.
        </Text>

        <View style={{margin: 3}} />
        <Text>
          <Text style={styles.subtitle1}>REFERENCES DU CONTRAT: </Text>
        </Text>
        <Text>
          <Text style={styles.subtitle2}>Agence: </Text> {detailContrat.agence}
          <Text style={styles.subtitle2}>{'   '}Police N°: </Text>{' '}
          {detailContrat.numeroPolice}
          <Text style={styles.subtitle2}>{'   '}Compte Souscripteur n°: </Text>
        </Text>
        <Text>
          <Text style={styles.subtitle2}>Date d'effet : </Text>{' '}
          {detailContrat.dateSouscription}
          <Text style={styles.subtitle2}>{'   '}Apporteur : </Text>
          <Text style={styles.subtitle2}>{'   '}Compte Assuré n° : </Text>
        </Text>
        <View style={{margin: 7}} />
        <Text>Conditions Générales référence n°020 450</Text>
      </View>
    </View>
  );
};
